
import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { formatNumber } from "@/utils/dataUtils/formatters";

interface SocialActionButtonProps {
  onClick: () => void;
  icon: ReactNode;
  count: number;
  tooltipText: string;
  buttonSize: string;
  colorClasses: string;
  iconSize: number;
  isActive?: boolean;
  iconClassName?: string;
}

export function SocialActionButton({
  onClick,
  icon,
  count,
  tooltipText,
  buttonSize,
  colorClasses,
  iconSize,
  isActive = false,
  iconClassName = "mr-1.5 transition-transform"
}: SocialActionButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          onClick={onClick}
          className={cn(
            buttonSize,
            colorClasses,
            "rounded-full transition-all duration-200",
            isActive ? "shadow-sm" : ""
          )}
        >
          {icon}
          <span className="tabular-nums text-xs font-medium">{formatNumber(count)}</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {tooltipText}
      </TooltipContent>
    </Tooltip>
  );
}
